import { render, staticRenderFns } from "./previewCourseDetail.vue?vue&type=template&id=74a58e75&scoped=true"
import script from "./previewCourseDetail.vue?vue&type=script&lang=js"
export * from "./previewCourseDetail.vue?vue&type=script&lang=js"
import style0 from "./previewCourseDetail.vue?vue&type=style&index=0&id=74a58e75&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a58e75",
  null
  
)

export default component.exports